import Error from "components/error"
import { ERROR } from "helpers/data-statuses"
import PropTypes from "prop-types"
import { useModelBetaFields } from "resources/beta"
import { useAssetViewData } from "connected-components/asset-view/hooks/use-asset-view-data"
import { usePositionSetBetaInstrument } from "../../helpers"
import { combineTanStackStatuses } from "helpers/data-statuses"
import AssetViewBetaComponent from "./component"

export default function AssetViewBeta({ instrumentsWithMetadata, ...props }) {
  const { modelId, endDate } = useAssetViewData()

  const [modelBetaFields, modelBetaFieldsStatus] = useModelBetaFields(modelId)
  const betaInstrument = usePositionSetBetaInstrument(instrumentsWithMetadata.original, { id: modelId, date: endDate })

  const status = combineTanStackStatuses([modelBetaFieldsStatus])

  if (status === ERROR) {
    return <Error />
  }

  return <AssetViewBetaComponent currentDate={endDate} betaInstrument={betaInstrument} betaFields={modelBetaFields} instrumentsWithMetadata={instrumentsWithMetadata} {...props} />
}

AssetViewBeta.propTypes = {
  modelMetadata: PropTypes.object.isRequired,
  instrumentsWithMetadata: PropTypes.object.isRequired,
}
